<div *ngIf="isLoaded" class="wistia_embed wistia_async_{{ video.url }}"></div>
